import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ebf30512&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=ebf30512&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf30512",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebf30512')) {
      api.createRecord('ebf30512', component.options)
    } else {
      api.reload('ebf30512', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ebf30512&scoped=true", function () {
      api.rerender('ebf30512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/program/programTask/index.vue"
export default component.exports